module.exports = __webpack_public_path__ + "components/modal-app-popup/static/chrome-icon-1043d17ce82d23baf126fd22de2843f4.webp";